export default __webpack_public_path__ + "static/media/pag20.278e2233.jpg";